import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=1350a7da&scoped=true&"
import script from "./Sales.vue?vue&type=script&lang=js&"
export * from "./Sales.vue?vue&type=script&lang=js&"
import style0 from "./Sales.vue?vue&type=style&index=0&id=1350a7da&prod&lang=scss&scoped=true&"
import style1 from "./Sales.vue?vue&type=style&index=1&id=1350a7da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350a7da",
  null
  
)

export default component.exports